// Const variables for size card product in product list
export const ITEM_SIZE = 90
export const MANUAL_SORTING_ITEM_SIZE = 110
export const RECYCLE_ITEM_SIZE = 101
export const RECYCLE_CATEGORY_SIZE = 35

export const CURRENCY_EUR = 'EUR'

export const swiperBreakpointsMessage = {
    600: {
        slidesPerView: 1.5
    },
    900: {
        slidesPerView: 2.1
    }
}

export const swiperBreakpointsPromotion = {
    250: {
        slidesPerView: 1.18
    },
    400: {
        slidesPerView: 1.4
    },
    500: {
        slidesPerView: 2.05
    },
    600: {
        slidesPerView: 2.25
    },
    800: {
        slidesPerView: 2.3
    },
    1000: {
        slidesPerView: 2.5
    },
    1500: {
        slidesPerView: 3.5
    },
    2000: {
        slidesPerView: 5
    }
}

export const swiperBreakpointsPromotionDashboard = {
    250: {
        slidesPerView: 1.5
    },
    350: {
        slidesPerView: 1.8
    },
    400: {
        slidesPerView: 2
    },
    500: {
        slidesPerView: 2.25
    },
    600: {
        slidesPerView: 2.5
    },
    700: {
        slidesPerView: 3
    },
    750: {
        slidesPerView: 3.25
    },
    800: {
        slidesPerView: 3.5
    },
    1000: {
        slidesPerView: 4
    },
    1200: {
        slidesPerView: 4.5
    },
    1500: {
        slidesPerView: 5
    }
}

export const MIN_VALUE = 0
export const INITIAL_TIMER = 200
export const TIMER_SUBSTRACTION = 20
export const TIMER_MIN = 60
export const ELLIPSIS_THRESHOLD = 3
export const FLAG_EMOJI_OFFSET = 127365

export const CARD_ITEM_HEIGHT = 'height: 100%'

export const PROFILE_INFO = ['email', 'phone', 'fax', 'streetName', 'streetNumber', 'postalCode', 'city']
export const PAGE_OPTIONS = [10, 20, 50]
